function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M19,9a1,1,0,0,1,1,1v9a1,1,0,0,1-1,1H1.01a1,1,0,0,1-1-1V2a1,1,0,0,1,1-1H9A1,1,0,0,1,9,3H2.01v9H6a.988.988,0,0,1,.89.55L7.62,14h4.76l.73-1.45A.977.977,0,0,1,14,12h4V10A1,1,0,0,1,19,9Zm-1,9V14H14.62l-.72,1.45A1.022,1.022,0,0,1,13,16H7a1.006,1.006,0,0,1-.89-.55L5.38,14H2.01v4ZM19.11.93a2.848,2.848,0,0,1,.88,2.05A3.955,3.955,0,0,1,18.7,5.71L15.73,8.69,14.71,9.71a1.038,1.038,0,0,1-.47.26l-4,1a1.007,1.007,0,0,1-.95-.26.985.985,0,0,1-.26-.95l1-4a.953.953,0,0,1,.26-.47l3.99-4a4.505,4.505,0,0,1,2-1.2,2.9,2.9,0,0,1,2.83.84ZM13.49,8.1l.09-.09L11.97,6.44l-.07.07-.53,2.12,2.12-.53Zm3.79-3.81c.36-.35,1.11-1.25.42-1.95A.964.964,0,0,0,17,2a.877.877,0,0,0-.24.03,2.515,2.515,0,0,0-1.06.68L13.38,5.03l1.61,1.56,2.29-2.3ZM18,14l-.01,3.96V18H18ZM.01,13v5.06a.34.34,0,0,1-.01-.1Z",
  transform: "translate(0 -0.003)",
  fill: "#949db2"
});

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    width: 20,
    height: 19.997,
    viewBox: "0 0 20 19.997"
  }, props), _ref);
};

export default __webpack_public_path__ + "storage/static/media/add-order.dbc5a543.svg";
export { SvgComponent as ReactComponent };